import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, EmployeeCardAddEdit } from './Pages';

export const RsmEmployeeRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing}/>
        <Route exact path = {`${match.path}/addEdit/:id?`} component={EmployeeCardAddEdit} />
    </Fragment>
)